/**
 * CAMASA CPS — Constantes e helpers compartilhados.
 *
 * Tudo que é usado em mais de um componente fica aqui:
 *  - URLs base (API/BACKEND)
 *  - Helpers de formatação (re-exportados de ./lib/fmt — fonte única de verdade)
 *  - Dicionários de label (ROLE_LBL, MAT_CAT, STATUS_OBRA, ESP_LBL)
 *  - Constantes de regras de negócio (AMBIENTES_SUGERIDOS, UNIDADES_MED, limites de upload)
 */

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const BACKEND = process.env.REACT_APP_BACKEND_URL;

/** Resolve URL de mídia: absoluta (http) ou relativa ao backend. */
export const fileUrl = (u) => !u ? "" : (u.startsWith("http") ? u : `${BACKEND}${u}`);

// Re-exporta os helpers de formatação. Fonte única de verdade em ./lib/fmt.js.
// Aliases mantidos: brl (= fmtMoeda), fmt (= fmtData) — para compat retroativa.
export {
  fmtData,
  fmtData as fmt,
  fmtDataHora,
  fmtDataCurta,
  fmtHora,
  fmtRelativo,
  fmtMoeda,
  fmtMoeda as brl,
  fmtMoedaOuTraco,
  fmtPct,
  parseData,
} from "./lib/fmt";

export const ROLE_LBL = {
  admin: "Administrador", financeiro: "Financeiro", gestor: "Gestor de Obras",
  terceirizado: "Terceirizado", cliente: "Cliente", arquiteto: "Arquiteto"
};

export const ESP_LBL = {
  medicao: "Medição", projeto: "Projeto", producao: "Produção",
  acabamento: "Acabamento", frete: "Frete", instalacao: "Instalação"
};

export const MAT_CAT = {
  marmore: "Mármore", quartzito: "Quartzito", granito: "Granito",
  quartzo_sinterizado: "Quartzo / Composto", travertino: "Travertino",
  onix: "Ônix", pedra: "Pedra", industrializado: "Industrializado"
};

export const STATUS_OBRA = {
  em_andamento: { l: "Em andamento", c: "run" },
  concluida: { l: "Concluída", c: "done" },
  arquivada: { l: "Arquivada", c: "hold" },
  cancelada: { l: "Cancelada", c: "hold" },
  pausada: { l: "Pausada", c: "hold" },
  rascunho: { l: "Rascunho", c: "hold" },
};

/** Ambientes sugeridos para Galeria por Ambiente do Signature Book. */
export const AMBIENTES_SUGERIDOS = [
  "Cozinha", "Banheiro Suíte", "Banheiro Social", "Lavabo", "Sala de Estar",
  "Sala de Jantar", "Quarto", "Closet", "Hall", "Área Externa", "Spa",
  "Piso Externo", "Outros"
];

/** Unidades aceitas no módulo Medições. */
export const UNIDADES_MED = ["m²", "m", "un", "pç", "kg", "h"];
